import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AltreNotLibriSocWarningService } from './warnings/altre-not-libri-soc.warnings';
import { AltreNotLibriSocialiStoreValidators } from './validators/altre-not-libri-soc.field-validators';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [AltreNotLibriSocWarningService, AltreNotLibriSocialiStoreValidators],
})
export class AltreNotLibriSocFormModule {}
